import { useSearchParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { PppcPolicyWizard } from "@/components/applications/pppc/PppcPolicyWizard";
import { useAllPppcPolicies } from "@/hooks/usePppcPolicy";

export default function NewPppcPolicyPage() {
  const [params] = useSearchParams();
  const duplicateId = params.get("duplicate");
  const { data: policies = [], isLoading } = useAllPppcPolicies();
  const [ready, setReady] = useState(!duplicateId);

  useEffect(() => {
    if (!duplicateId) return;
    if (!isLoading) setReady(true);
  }, [duplicateId, isLoading]);

  if (!ready) {
    return (
      <div className="min-h-screen flex items-center justify-center text-muted-foreground">
        Loading…
      </div>
    );
  }

  const source = duplicateId
    ? policies.find((p) => p.policyId === duplicateId)
    : undefined;

  return (
    <PppcPolicyWizard
      initial={
        source
          ? {
              target: {
                mode: "external",
                appName: source.appName ? `${source.appName} (copy)` : "",
                identifier: source.identifier,
                identifierType: source.identifierType,
              },
              permissions: {
                codeRequirement: source.codeRequirement,
                choices: source.choices,
              },
            }
          : undefined
      }
    />
  );
}
